<template>
    
    <BTabs class="nav-tabs-clean" content-class="mt-3">
        <BTab title="Запрошення по підписці" active>
            <div>
                <BOverlay :show="is_load">
                    <BTable striped :items="items" :fields="fields" show-empty >
                        <template  v-slot:cell(edrpou)="data">
                            <a :href="'/kontrahenty/' + data.item.user_id" target="_blank" >
                                {{data.item?.edrpou}}
                            </a>
                        </template>
                        
                        <template  v-slot:cell(email)="data">
                            <a :href="'/kontrahenty/' + data.item.user_id" target="_blank" >
                                {{data.item?.email}}
                            </a>
                        </template>
                        
                        
                        <template  v-slot:cell(user_id)="data">
                            <a :href="'/kontrahenty/' + data.item.user_id" target="_blank" >
                                {{data.item?.user_id}}
                            </a>
                        </template>
                    </BTable>
                </BOverlay>
            </div>
        </BTab>
        
        <BTab title="Запрошення вручну" >
            <div class="border p-2">
                <div class="panel-tag mb-0">
                    Дані користувачі додані вручну, для участі мають пройти реєстрацію
                </div>
                <BOverlay :show="is_load">
                    <BTable striped :items="invitations" :fields="inv_fields" show-empty ></BTable>
                </BOverlay>
            </div>
        </BTab>
    </BTabs>
  
    
    
</template>


<script>

import {
    BOverlay,
    BTable,
    BTabs,
    BTab
} from 'bootstrap-vue-next';

export default {
    name: "tender_subscribes",
    props : {
        tender: {
            type: Object,
            required: true
        }
    },
    
    components : {
        BTable,
        BOverlay,
        BTabs,
        BTab
    },
    
    data() {
        return {
            items : [],
            invitations : [],
            is_load : false,
            fields : [
                { key: 'user_id', label: 'ID' },
                { key: 'email', label: 'Email'  },
                { key: 'edrpou', label: 'ЄДРПОУ'  },
                { key: 'contact_tel', label: 'Телефон'  },
                { key: 'company', label: 'Контрагент'  },
            ],
            
            inv_fields : [
                { key: 'id', label: 'ID' },
                { key: 'email', label: 'Email'  },
                { key: 'contact', label: 'Контрагент'  },
            ],
        }
    },
    
    created() {
        this.loadSubscribes();
        this.loadInvitations();
    },
    
    methods : {
        
        async loadInvitations() {
            this.is_load = true;
            this.invitations = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/inside/invitations").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.invitations = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        async loadSubscribes() {
            this.is_load = true;
            this.items = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/inside/subscribes").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
}
</script>


<style scoped>

</style>